import React from 'react';
import ScrollWrapper from '@components/Atoms/ScrollWrapper';
import TestletView from './Components/Views/TestletView';
import TestBreadcrumbsFilter from './Components/TestBreadCrumbsFilter';

const TestContainer = () => (
  // @todo add ElementAnalytics provider
  <>
    <TestBreadcrumbsFilter currentPage="" />
    <ScrollWrapper
      sx={{ height: 'calc(100vh - 5em)' }}
      contentProps={{
        tabIndex: 0,
        role: 'region',
        'aria-label': 'Test content',
      }}
    >
      <TestletView />
    </ScrollWrapper>
  </>
);

export default TestContainer;
